// Edge detail views (left panel + edge tables) - English
export default {
  common: {
    loading: "Loading...",
    copySuccess: "Copied!",
    noticeTitle: "Notice",
    successTitle: "Success",
    errorTitle: "Error",
    totalPrefix: "Total ",
    totalSuffix: " items",
    unitTx: "tx",
    averagePrefix: "Avg ",
    noData: "No data",
    viewInExplorer: "View in Explorer",
    notePrefix: "Note:",
    itemsUnit: "items",
    // Added for hash note table actions
    addSurvey: "Add to Survey",
    normalSurvey: "Normal Survey",
    importantSurvey: "Important Survey",
    note: "Note",
    tipTitle: "Notice",
  },
  fields: {
    ownership: "Address Ownership",
    watchingAddress: "Watching Address",
    inflow: "Inflow",
    outflow: "Outflow",
    firstInflow: "First Inflow",
    CoinJoin:'CoinJoin Transaction',
    crossChainSwap: "Cross-chain Swap",
    sameIPShort: "Same Time · Same IP",
    sameDeviceShort: "Same Device Account",
  },
  titles: {
    transactionDetails: "Transaction Details",
    sameIP: "Same Time Window · Same IP Details",
    sameDevice: "Same Device Details",
    crossChain: "Cross-chain Transaction Details",
    hashNote: "Hash Notes",
    coinJoin: "CoinJoin Transaction Details",
  },
  messages: {
    notAllowSurvey: "This item cannot be added to survey",
    addressNotFound: "No matching address was found",
    downloadFailed: "Download failed, please try again later",
    fetchFailed: "Failed to fetch data, please try again later",
    surveyAdded: "Added to survey",
    copySuccess: "Copied successfully!",
  },
  coinJoinTrace: {
    title: "CoinJoin Trace",
    subtitle: "Quickly locate the CoinJoin transaction and trace it on the graph",
    timeLabel: "Trace Time",
    rangeLabel: "Trace Range",
    traceButton: "Trace Graph",
    rangeOptions: {
      8: "8 Hours",
      16: "16 Hours",
      24: "24 Hours",
      48: "48 Hours",
    },
  },
  leftEdge: {
    sender: "Sender",
    receiver: "Receiver",
    crossChainTooltip:
      "Bridgers cross-chain may involve three platforms. In third-party explorers, switch among OmniBridge, Bridgers, and CrossChainX to view cross-chain data.",
    stargateTooltip:"Supports data tracking for Stargate cross-chain protocol. Click 'Cross-chain Trace' to quickly query and visualize cross-chain data.",
  },
  summary: {
    totalCountLabel: " Total Count:",
    totalQuantityLabel: " Total Quantity:",
    averageQuantityLabel: "Average Quantity:",
  },
  sameIP: {
    topNotice:
      "Current results show {timeRange} same-IP logins. To change the time window, go to [Extended Config] - [Same Time Window · Same IP] to configure.",
    topNoticePrefix: "Current results show",
    topNoticeSuffix:
      " same-IP logins. To change the time window, go to [Extended Config] - [Same Time Window · Same IP] to configure.",
    labels: {
      ip: "IP",
      locationPrefix: "Location:",
      currentUser: "[Current User]",
      loginTime: "[Login Time]",
      sameIPUser: "[Same-IP User]",
    },
    timeOptions: {
      ONE_DAY: "1 day",
      THREE_DAY: "3 days",
      ONE_WEEK: "1 week",
      ONE_MONTH: "1 month",
      THREE_MONTH: "3 months",
      HALF_A_YEA: "6 months",
      NOT_LIMIT: "All",
    },
  },
  sameDevice: {
    columns: {
      manufacturer: "Manufacturer",
      model: "Model",
      osVersion: "OS Version",
      deviceId: "Device ID (UUID)",
      imei: "IMEI",
      mac: "MAC",
    },
  },
  firstRecord: {
    columns: {
      orderNo: "Order No",
      txHash: "Tx Hash",
      quantity: "Quantity",
      time: "Time",
      actions: "Actions",
    },
    actions: {
      note: "Note",
      survey: "Survey",
      surveyNormal: "Normal Survey",
      surveyImportant: "Important Survey",
    },
  },
  dealEdge: {
    filters: {
      time: "Time",
      startDate: "Start date",
      endDate: "End date",
      amountRange: "Amount Range",
      minAmount: "Min amount",
      maxAmount: "Max amount",
    },
    totalPrefix: "Total",
    totalSuffix: " items",
    buttons: {
      download: "Download",
      joinSurvey: "Add to Survey",
    },
    columns: {
      orderNo: "Order No",
      txHash: "Tx Hash",
      quantity: "Quantity",
      time: "Time",
      fromUserId: "Sender User ID",
      toUserId: "Receiver User ID",
      note: "Note",
    },
    tooltips: {
      hashContainsMore:
        "This tx hash contains more token transfer records. View details for more.",
    },
  },
  noteHistory: {
    dialogTitle: "Note History",
    totalPrefix: "Total:",
    columns: {
      noteContent: "Note Content",
      modifier: "Updated By",
      modifiedTime: "Updated At",
    },
  },
  hashNoteDialog: {
    title: "Note",
    placeholder: "Enter note content",
    history: "Note History",
    cancel: "Cancel",
    confirm: "Confirm",
    addSuccess: "Hash note added successfully!",
    updateSuccess: "Hash note updated successfully!",
    deleteSuccess: "Hash note deleted successfully!",
  },
};
